import { DEFAULT_PRICE_APPLICATION_CONFIG } from './constants';
import { PermittedUser, PriceApplicationConfig, PricingPermissionConfigResponse, UpdatePricingPermissionConfigRequest } from './types';

const normalizeSearchText = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

export const normalizePriceApplicationConfig = (response: PricingPermissionConfigResponse | null | undefined): PriceApplicationConfig => {
  const priceApplication = response?.price_application;

  return {
    mode: priceApplication?.mode ?? DEFAULT_PRICE_APPLICATION_CONFIG.mode,
    users: priceApplication?.users ?? [],
  };
};

// Em "Todos os usuários" a API não devolve a lista, então a tela não a conhece: mandar `users` apagaria a lista
// que o back guarda para quando o modo voltar a "Usuários específicos".
export const buildPriceApplicationRequest = ({ mode, users }: PriceApplicationConfig): UpdatePricingPermissionConfigRequest => ({
  price_application: mode === 'SPECIFIC_USERS' ? { mode, users } : { mode },
});

export const sortUsersByName = (users: PermittedUser[]): PermittedUser[] =>
  [...users].sort(
    (left, right) =>
      left.user_name.localeCompare(right.user_name, 'pt-BR', { sensitivity: 'base' }) ||
      left.user_email.localeCompare(right.user_email, 'pt-BR', { sensitivity: 'base' }) ||
      left.cd_usuario - right.cd_usuario,
  );

export const filterUsers = (users: PermittedUser[], search: string): PermittedUser[] => {
  const term = normalizeSearchText(search);

  if (!term) return users;

  return users.filter(user => normalizeSearchText(user.user_name).includes(term) || normalizeSearchText(user.user_email).includes(term));
};

export const mergeWithSelectedUsers = (contractUsers: PermittedUser[], selectedUsers: PermittedUser[]): PermittedUser[] => {
  const contractIds = new Set(contractUsers.map(user => user.cd_usuario));
  const missingSelectedUsers = selectedUsers.filter(user => !contractIds.has(user.cd_usuario));

  return sortUsersByName([...contractUsers, ...missingSelectedUsers]);
};

export const formatSelectedUsersCount = (count: number): string =>
  count === 1 ? '1 usuário selecionado' : `${count} usuários selecionados`;
